import React, { memo, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Loader from "react-js-loader";
import { ToastContainer, toast } from 'react-toastify';
import { getEndpointUrl } from "../../Utils/Common";

const ModalFinisInspectionMultiple = ({ onCallback, dataSelected, show, close, status }) => {

    const [isLoading, setLoading] = useState(false);

    const [userLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    useEffect(() => {

    }, [isLoading, dataSelected, status]);

    const onSetStatus = () => {
        setLoading(true);

        let idDeleted = [];
        dataSelected.map(row => idDeleted.push(row.id));

        fetch(getEndpointUrl() + `/checkpoint/status`, {
            method: "PUT",
            body: new URLSearchParams({
                user_id: userLogin.id,
                status: status,
                id: idDeleted
            }),
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            setLoading(false);

            if (json.status === 'ok') {

                toast.success("Yay, Data inspeksi berhasil diubah.", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                });

                onCallback(dataSelected);

                close()
            } else {
                toast.error(json.message, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true
                });
            }
        }).catch(error => {
            setLoading(false);
        });
    };
    return (
        <>
            <ToastContainer position="top-end" className="p-3"></ToastContainer>
            <Modal show={show} onHide={close} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Selesaikan {status == 'selesai' ? "menyelesaikan" : "membatalkan"} ini?</Modal.Title>
                </Modal.Header>
                {isLoading ?
                    <Modal.Body>
                        <div className="d-flex justify-content-center mt-5 mb-5">
                            <Loader type="bubble-scale" bgColor={"#E57373"} size={100} />
                        </div>
                    </Modal.Body>
                    :
                    <>
                        <Modal.Body>
                            <p className="mb-0">Yakin anda akan {status == 'selesai' ? "menyelesaikan" : "membatalkan"} pekerjaan ini?</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={close}> Batal </Button>
                            <Button variant={status == 'selesai' ? "success" : "danger"} onClick={onSetStatus}>{status == 'selesai' ? "Selesaikan" : "Batalkan"}</Button>
                        </Modal.Footer>
                    </>
                }
            </Modal>
        </>
    );
}

export default memo(ModalFinisInspectionMultiple);
